export default "__VITE_ASSET__DwNdZVCz__"